import React from 'react';
import { FaRegNewspaper } from 'react-icons/fa';
import SharedHeader from '../../../components/SharedHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import UnderConstruction from '../../../components/UnderConstruction';
import './marketing_posts.css';

const MarketingPosts = () => {
  return (
    <div className="marketing_posts_page">
      <SharedHeader />
      
      <div className="marketing_posts_container">
        <header className="marketing_posts_header">
          <div className="marketing_posts_header_icon">
            <FaRegNewspaper />
          </div>
          <h1>Marketing Posts</h1>
          <p>Create and manage your marketing posts</p>
        </header>

        {/* Under Construction Notice */}
        <UnderConstruction pageName="Marketing Posts" />
      </div>

      <DashboardFooter />
    </div>
  );
};

export default MarketingPosts;